module.exports = __webpack_public_path__ + "static/media/delete.4c1e45b4.svg";